import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { EmailBaseCampaign, Segment } from '@feathr/blackbox';
import { getSegmentUniqueEmailsPayload } from '@feathr/blackbox';
import { useUniqueEmails } from '@feathr/extender/hooks';

import SegmentDataChip from '../SegmentDataChip';

interface ISegmentAudienceChipsProps {
  campaign: EmailBaseCampaign;
  segment: Segment;
}

function SegmentAudienceChips({
  campaign,
  segment,
}: Readonly<ISegmentAudienceChipsProps>): JSX.Element {
  const counts = useUniqueEmails(
    (Segments) => getSegmentUniqueEmailsPayload(Segments, campaign, segment.id),
    [campaign, segment.id],
  );

  return (
    <>
      <SegmentDataChip
        name={`${segment.id}-num_users_total`}
        statType={'num_users_total'}
        statValue={counts?.num_persons}
      />
      <SegmentDataChip
        name={`${segment.id}-num_emails_total`}
        statType={campaign.includesAdditionalEmails ? 'num_emails_total' : 'num_emails_primary'}
        statValue={counts?.unique_emails}
      />
    </>
  );
}

export default observer(SegmentAudienceChips);
